const projectInfo = [
  {
    id: 0,
    projNo: '00',
    bgImgUrl: 'ship_me_this_job.png',
    title: 'shipMeThisJob',
    tagline: 'Full-Stack Platform · Next.js · TypeScript · PostgreSQL · 50+ ATS Integrations',
    overview:
      'Built a production-grade, multi-user job discovery and application tracking platform that scrapes 100+ companies across 50+ ATS integrations daily, processes hundreds of listings, and serves a real-time Kanban dashboard for managing application pipelines. Features layered caching (ISR + Redis + in-memory), property-based testing, and a pluggable source handler architecture.',
    impact: [
      'Monitors 100+ companies (Google, Microsoft, Meta, Amazon, Stripe, OpenAI, etc.) across 50+ distinct ATS integrations - Greenhouse, Lever, Ashby, Workday, and more.',
      'Processes hundreds of job listings per daily cron run with concurrent execution, per-source rate limiting, and cross-source deduplication.',
      'Serves multiple authenticated users with fully isolated data, invite-based registration, and per-user personalized filtering across 5 dimensions.',
      '26 database tables, 65+ API endpoints, 16+ dashboard routes - from Kanban pipeline tracking to hiring trend analytics with Sankey charts.',
    ],
    challenges: [
      'Designing a pluggable source handler architecture (50+ handlers across 3 tiers: structured APIs, HTML scraping with Cheerio, and Playwright browser automation) that allows adding new companies with zero pipeline code changes.',
      'Building a resilient pipeline with Bottleneck rate limiting, exponential backoff retries, incremental checkpointing, and graceful shutdown - surviving 40-minute timeout budgets without data loss.',
      'Implementing a three-tier caching strategy (ISR for shared routes, Upstash Redis per-user with 30s TTL, in-memory safety net) to minimize Neon serverless cold starts while keeping data fresh.',
      'Achieving cross-source deduplication using deterministic job IDs to detect the same role posted on multiple boards without UUID collision risks.',
      'Running real Postgres semantics in tests via PGlite (WASM-based in-memory Postgres) - zero Docker, zero network, sub-second setup with property-based testing via fast-check.',
    ],
    visitLink: 'https://shipmethisjob.dev',
    sourceLink: 'https://github.com/kartikth40/shipMeThisJob',
    privateSource: true,
    techUsed: ['Next.js', 'TypeScript', 'PostgreSQL', 'Drizzle ORM', 'Playwright', 'Redis', 'Vitest'],
  },
  {
    id: 1,
    projNo: '01',
    bgImgUrl: 'purrfect_focus.png',
    title: 'Purrfect Pomodoro Timer',
    tagline: 'Chrome Extension · 1,500+ Weekly Active Users · 20+ Countries',
    overview:
      'Built a Chrome extension with persistent local state management, session analytics, and offline-first architecture, serving 1,500+ weekly active users across 20+ countries without dedicated backend infrastructure. Features customizable focus/break timers, task labels, a daily journal, built-in site blocking during focus sessions, ambient music player, 6-month calendar history, and full data export/import.',
    impact: [
      'Serves 1,500+ weekly active users across 20+ countries - grown organically with zero marketing spend.',
      'Consistently rated 4.9+ stars on the Chrome Web Store.',
      'Feature set expanded from a simple timer to a full productivity suite - site blocking, journaling, session analytics, and ambient audio.',
    ],
    challenges: [
      'Persisting and querying 6 months of session history efficiently using Chrome Storage API within strict extension memory limits.',
      'Designing a reliable background timer that survives tab switches, browser restarts, and Chrome\'s service worker lifecycle (Manifest V3).',
      'Implementing site blocking that integrates with Chrome\'s declarativeNetRequest API while respecting user whitelist preferences.',
      'Building a data export/import system that remains backward-compatible across extension updates.',
    ],
    visitLink: 'https://chromewebstore.google.com/detail/aobapnhgpjlldncjopmbbfeoomombhel?hl=en-GB',
    sourceLink: 'https://github.com/kartikth40/PurrfectFocus',
    techUsed: ['JavaScript', 'HTML', 'CSS', 'Chrome Extension API', 'Manifest V3'],
  },
  {
    id: 2,
    projNo: '02',
    bgImgUrl: 'have_small_bytes.png',
    title: 'Have Small Bytes',
    tagline: 'Full-Stack Blog · Next.js · TypeScript · GraphQL · NextAuth.js',
    overview:
      'Built a resilient content aggregation platform with GraphQL data orchestration, retry-aware caching, ISR revalidation, and rate-limit recovery mechanisms to minimize upstream API pressure. Features 50+ service functions, React cache() deduplication, and multi-flow authentication.',
    impact: [
      'GraphQL data layer with React cache() deduplication significantly reduces redundant CMS API calls under throttling.',
      'ISR revalidation ensures content stays fresh without full rebuilds, keeping page loads fast.',
      'Multi-flow auth (email, username, OTP-based passwordless) covers a wide range of user preferences securely.',
    ],
    challenges: [
      'Built a resilient GraphQL data layer (50+ service functions) with React cache() deduplication, 5x retry on rate-limit errors, and ISR revalidation to minimize CMS API calls under throttling constraints.',
      'Implemented multi-flow auth (email, username, OTP-based passwordless) with bcrypt-hashed OTP storage and async real-time field uniqueness validation against a live API.',
      'Designing a GraphQL schema flexible enough to support multiple blog categories with shared and category-specific fields.',
      'Handling rapid like/unlike toggling without race conditions - debounced API calls with optimistic UI updates to keep interactions snappy while ensuring final state stays consistent with the backend.',
    ],
    visitLink: 'https://havesmallbytes.vercel.app',
    sourceLink: 'https://github.com/kartikth40/have-small-bytes',
    privateSource: false,
    techUsed: ['Next.js', 'TypeScript', 'GraphQL', 'NextAuth.js', 'React', 'ISR', 'CSS'],
  },
]

export default projectInfo
